import memento from './memento.png'

const content = `<p>The Memento design pattern consists in letting objects produce a representation of their internal state that only them can read, but that a handler can store and pass them back later.</p>

<img src=${memento} alt="memento" />

<p>To implement the Memento design pattern, the object needs a privileged access to the memento. Indeed, only the object knows what the memento contains, as it represents its internal state.</p>

<p>How to achieves this depends on the language. For example in C++ Memento can rely on static casting or friendship between classes. In Ruby the methods of the Memento can be private and the object can use <code>send</code> to call them.</p>

<p>There is a strong coupling between the object and its memento, but there is <a href="/low-coupling">Low coupling</a> between the rest of the code and the Memento. Indeed, any other object can store the Memento and restore the previous state of the object that produced the memento without knowing what’s in it.</p>

<div class="notes">
<p>Key points</p>

<ul><li>Memento allows an object to export its internal state without revealing it to the rest of the code</li><li>Other objects can store the memento and restore the object that produced it to a previous state</li></ul>
</div>`

export default content
